export const ENDMILE_API_EVENT_LIST = {
  PRODUCT_VIEWED: "Product viewed",
  ADD_TO_CART: "Product_clicked_add_to card",
  BUY_NOW: "product_buynow_clicked",
  ADD_TO_WISHLIST: "product_wishlist_clicked",
  PROCEED_TO_CHECKOUT: "cart_proceedtocheckout_clicked",
  SIGN_UP_INITIATE: "user_signup_initiated",
  SIGN_UP_CONFIRMED: "user_signup_confirmed",
  SIGNED_IN: "user_signedin",
  VIRTUAL_TRIAL: "virtualbooktrial",

  // learning
  PAGE_VISITED: "page_visited",
  EVENT_VIEWED: "event_viewed",
  CHECKOUT_PROCEED_TO_PAY_CLICKED: "checkout_proceedtopay_clicked",
  PAYMENT_INITIATED: "payment_initiated",
  PAYMENT_SUCCESSFUL: "payment_successfull",
  PAYMENT_FAILED: "payment_failed",
  ORDER_CONFIRMED: "order_confirmed",
  CTA_CLICKED: "CTA_clicked",
  WEB_TRIAL: "WEB_TRIAL",
  REGISTER_FREE_EVENT_SESSION: "register_free_event_session",
};

export const ENDMILE_API_FIELD_ID_MAPPING_LIST = {
  LOCATION: "53",
  CITY: "53",
  CID: "61",
  PRODUCT_SUB_CATEGORY: "70",
  CART_SIZE: "176",
  PAYMENT_MODE: "178",
  PROMO_CODE: "179",
  COURSE: "189",
  COURSE_LEVEL: "190",
  YEAR_OF_ATTEMPT: "191",
  MONTH_OF_ATTEMPT: "192",
  COURSE_SUBJECT: "193",
  EXAM: "217",

  // learning new
  EVENT_TYPE: "219",

  FIRST_NAME_LAST_NAME: "8",
  COUNRTY_CODE: "226",
  PHONE_NUMBER: "36",
  INSTITUTES: "218", // need to replaced with company name
  STATE: "76",
  DESGNATION: "56",
  AREA_OF_SPECIALIZATION: "75",
  PROFESSION: "60",

  WEBINAR_CATEGORY: "224",
  PAGE_URL: "207", // Previously it was 171 (Bucket Name on Endmile dashbaord) but change to 207
  EVENT_ID: "222",
  SESSION_ID: "221",
  PRODUCT_NAME: "73", // event name
  SESSION_NAME: "220",
  WEBINAR_SUBJECT: "225",
  WEBINAR_LEVEL: "223",

  PRODUCT_SERVICES: "25", //plan name - Free Trail, Annual Subscription
  ACTIVATON_DATE: "26",
  EXPIRY_DATE: "27",

  ORDER_VALUE: "177",
  TRANSACTION_ID: "180",
  TRANSACTION_AMOUNT: "181",
  TRANSACTION_DATE: "182",
  TRANSACTION_TIME: "183",
  PAYMENT_METHOD: "184",
  ORDER_ID: "185",
  ORDER_AMOUNT: "186",
  ORDER_DATE: "187",
  ORDER_TIME: "188",

  UTM_SOURCE: "63",
  UTM_MEDIUM: "62",
  UTM_CAMPAIGN: "61",
};

export const ENDMILE_API_CONSTANT = {
  CID: "cid",
  INTERNAL: "internal",
  OID: "OID",
  TID: "TID",
};
